export const IP_ACCOUNT_ERROR_CODES = [
  "IP_ACCOUNT_NOT_FOUND",
  "IP_ACCOUNT_INACTIVE",
  "IP_ACCOUNT_EXPIRED",
];

export function isIpAccountError(code?: string | null): boolean {
  if (!code) return false;
  return IP_ACCOUNT_ERROR_CODES.includes(code);
}
